// Общие переиспользуемые стили
import { theme } from '../../config/theme';

export const commonStyles = {
    // Контейнеры
    container: {
        maxWidth: '1000px',
        margin: '0 auto',
        padding: '0 1rem',
    },
    
    containerCentered: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        padding: theme.spacing.lg,
    },
    
    // Карточки
    card: {
        background: theme.colors.parchmentPaper,
        padding: theme.spacing.xl,
        borderRadius: theme.borderRadius.lg,
        boxShadow: theme.shadows.md,
        border: `1px solid ${theme.colors.borderMedium}`,
    },
    
    // Кнопки
    button: {
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        borderRadius: theme.borderRadius.md,
        fontSize: theme.fontSize.base,
        fontWeight: theme.fontWeight.semibold,
        cursor: 'pointer',
        border: 'none',
        transition: `all ${theme.transitions.default}`,
    },
    
    buttonPrimary: {
        backgroundColor: theme.colors.parchmentPaper,
        color: theme.colors.ink,
        border: `2px solid ${theme.colors.ink}`,
    },

    buttonSecondary: {
        backgroundColor: theme.colors.parchmentDark,
        color: theme.colors.ink,
        border: `2px solid ${theme.colors.borderDark}`,
    },

    buttonDanger: {
        backgroundColor: theme.colors.errorBg,
        color: theme.colors.errorText,
        border: `2px solid ${theme.colors.danger}`,
    },
    
    // Инпуты
    input: {
        padding: theme.spacing.sm,
        border: `1px solid ${theme.colors.borderMedium}`,
        borderRadius: theme.borderRadius.sm,
        fontSize: theme.fontSize.base,
        width: '100%',
        boxSizing: 'border-box',
    },
    
    // Заголовки
    title: {
        fontSize: theme.fontSize['4xl'],
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.textPrimary,
        marginBottom: theme.spacing.lg,
    },
    
    titleLarge: {
        fontSize: theme.fontSize['3xl'],
        fontWeight: theme.fontWeight.bold,
        color: theme.colors.textPrimary,
    },
    
    // Формы
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.md,
    },
    
    inputGroup: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.xs,
    },
    
    // Загрузка
    loadingContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: theme.colors.bgSecondary,
        fontFamily: 'Arial, sans-serif',
    },
    
    loadingSpinner: {
        width: '40px',
        height: '40px',
        border: `4px solid ${theme.colors.bgTertiary}`,
        borderTop: `4px solid ${theme.colors.ink}`,
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        marginBottom: theme.spacing.lg,
    },
    
    // Ошибки
    error: {
        backgroundColor: theme.colors.errorBg,
        color: theme.colors.errorText,
        padding: theme.spacing.sm,
        borderRadius: theme.borderRadius.sm,
        border: `1px solid ${theme.colors.errorBorder}`,
        textAlign: 'center',
    },
    
    // Таблицы
    tableWrapper: {
        overflowX: 'auto',
        borderRadius: theme.borderRadius.lg,
        border: `1px solid ${theme.colors.borderMedium}`,
    },
    
    table: {
        width: '100%',
        borderCollapse: 'collapse',
        backgroundColor: theme.colors.bgPrimary,
        minWidth: '500px',
    },
    
    tableHeader: {
        backgroundColor: theme.colors.tableHeaderBlue,
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        textAlign: 'left',
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.ink,
        borderBottom: `2px solid ${theme.colors.borderDark}`,
    },
    
    tableRow: {
        cursor: 'pointer',
        transition: `background-color ${theme.transitions.fast}`,
    },
    
    tableCell: {
        padding: `${theme.spacing.sm} ${theme.spacing.md}`,
        borderBottom: `1px solid ${theme.colors.borderLight}`,
        color: theme.colors.ink,
    },
    
    // Карточки статистики
    statCard: {
        backgroundColor: theme.colors.parchmentPaper,
        padding: theme.spacing.lg,
        borderRadius: theme.borderRadius.xl,
        boxShadow: theme.shadows.lg,
        border: `1px solid ${theme.colors.borderMedium}`,
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.md,
        transition: `transform ${theme.transitions.default}, box-shadow ${theme.transitions.default}`,
    },
    
    statCardLink: {
        textDecoration: 'none',
        color: 'inherit',
        cursor: 'pointer',
    },
    
    // Сетки
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: theme.spacing.lg,
    },
    
    gridCompact: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: theme.spacing.lg,
    },
    
    // Табы
    tabs: {
        display: 'flex',
        gap: theme.spacing.sm,
        marginBottom: theme.spacing.lg,
    },
    
    tabButton: {
        padding: `${theme.spacing.xs} ${theme.spacing.md}`,
        border: `1px solid ${theme.colors.borderMedium}`,
        background: theme.colors.bgTertiary,
        borderRadius: theme.borderRadius.md,
        cursor: 'pointer',
        fontSize: theme.fontSize.base,
    },
    
    tabButtonActive: {
        background: theme.colors.tableHeaderBlue,
        color: theme.colors.ink,
        border: `1px solid ${theme.colors.borderDark}`,
    },
    
    // Секции
    section: {
        marginBottom: theme.spacing.lg,
    },
    
    sectionTitle: {
        fontSize: theme.fontSize.xl,
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.textPrimary,
        marginBottom: theme.spacing.lg,
    },
    
    // Флекс контейнеры
    flexRow: {
        display: 'flex',
        gap: theme.spacing.md,
        flexWrap: 'wrap',
    },
    
    flexColumn: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing.md,
    },
    
    // Информационные блоки
    info: {
        textAlign: 'center',
        marginTop: theme.spacing.lg,
        paddingTop: theme.spacing.lg,
        borderTop: `1px solid ${theme.colors.borderLight}`,
        color: theme.colors.textLight,
        fontSize: theme.fontSize.sm,
    },
    
    // Футер действий
    footerActions: {
        marginTop: theme.spacing.xl,
        paddingTop: theme.spacing.md,
        borderTop: `1px solid ${theme.colors.borderLight}`,
    },
    
    // Сообщения
    success: {
        padding: theme.spacing.md,
        backgroundColor: 'rgba(200, 220, 190, 0.65)',
        color: theme.colors.success,
        borderRadius: theme.borderRadius.md,
        marginBottom: theme.spacing.md,
        border: `1px solid ${theme.colors.success}`,
    },
    
    errorText: {
        color: theme.colors.danger,
        fontSize: theme.fontSize.sm,
        marginTop: theme.spacing.xs,
    },
};

